import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || '';
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      navigate('/', { replace: true });
      return;
    }

    (async () => {
      try {
        await axios.post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true });
        await checkAuth();
      } catch (e) {
        console.error('Auth exchange failed', e);
      } finally {
        window.history.replaceState({}, document.title, '/');
        navigate('/', { replace: true });
      }
    })();
  }, [location.hash, navigate, checkAuth]);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--gk-cream)' }}>
      <div style={{ textAlign: 'center' }}>
        <div className="font-serif text-2xl font-bold" style={{ color: 'var(--gk-green-dark)' }}>Signing you in...</div>
        <div className="text-sm mt-2" style={{ color: 'var(--gk-muted)' }}>Just a moment while we welcome you to the Gaon family.</div>
      </div>
    </div>
  );
}
